import { useEffect, useState } from "react";
import { getValidSpotifyToken } from "../utils/spotify-auth";

export function useSpotifyPlayer() {
    const [currentlyPlaying, setCurrentlyPlaying] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    
    useEffect(() => {
        const checkPlaying = async () => {
            try {
                const token = await getValidSpotifyToken();
                const response = await fetch('https://api.spotify.com/v1/me/player/currently-playing?market=from_token', {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                
                if (response.status === 204) {
                    setCurrentlyPlaying(null);
                    setIsPlaying(false);
                    return;
                }
                
                if (response.ok) {
                    const data = await response.json();
                    setCurrentlyPlaying(data);
                    setIsPlaying(data.is_playing);
                }
            } catch (error) {
                console.error('Error checking current track:', error);
            }
        };
        
        checkPlaying();
        const interval = setInterval(checkPlaying, 5000);
        return () => clearInterval(interval);
    }, []);
    
    return { currentlyPlaying, isPlaying };
}

export function NowPlaying({ currentlyPlaying, isPlaying }) {
    if (!currentlyPlaying?.item) {
        return (
            <div className="mb-4 p-4 bg-gray-50 rounded-lg">
                <p className="text-gray-500">Not playing anything</p>
            </div>
        );
    }

    const { item } = currentlyPlaying;

    return (
        <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-4">
                {item.album.images[0]?.url && (
                    <img
                        src={item.album.images[0].url}
                        alt={`${item.album.name} album art`}
                        className="w-16 h-16 rounded"
                    />
                )}
                <div>
                    <p className="font-bold">{item.name}</p>
                    <p className="text-gray-600">
                        {item.artists.map((artist, index) => (
                            <span key={artist.id}>
                                {index > 0 ? ", " : ""}
                                {artist.name}
                            </span>
                        ))}
                    </p>
                    <p className="text-sm">
                        {isPlaying ? (
                            <span className="text-green-500">▶ Playing</span>
                        ) : (
                            <span className="text-gray-500">⏸ Paused</span>
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
}